import { api } from "..";

import { QueryProps } from "@/types/Api";
import { CreditFeature, CreditTier } from "@/types/CreditTier";

export interface GetCreditTiersQueryParams {
  feature: CreditFeature;
}

export const getCreditTiers = async (
  props: QueryProps<GetCreditTiersQueryParams>
): Promise<CreditTier[]> => {
  const res = await api.client.get("/credit-tiers", {
    signal: props.signal,
    params: { feature: props.params.feature },
  });
  return res.data;
};
